import { useMemo } from "react";
import SaltoVisitorTypesView from "./SaltoVisitorTypesView";
import { useLanguageContext } from "../../../../context/LanguageContext";

function SaltoVisitorTypes({
  configData,
  setConfigData,
  saltoResources,
  visitorTypes,
}) {
  const { translateEntity } = useLanguageContext();

  const visitorTypeLabels = useMemo(() => {
    return visitorTypes.reduce((labels, visitorType) => {
      labels[visitorType.id] = translateEntity(visitorType, "label");
      return labels;
    }, {});
  }, [visitorTypes, translateEntity]);

  const availableVisitorTypes = useMemo(() => {
    return visitorTypes.filter((visitorType) => {
      return !configData.visitor_types.some(
        (configVisitorType) =>
          configVisitorType.visitor_type_id === visitorType.id,
      );
    });
  }, [visitorTypes, configData]);

  /**
   * This method will add a visitor type to the config data
   * @param {int} visitorTypeId
   */
  function onVisitorTypeAdd(visitorTypeId) {
    setConfigData((prev) => ({
      ...prev,
      visitor_types: [
        ...prev.visitor_types,
        {
          visitor_type_id: visitorTypeId,
          access_group_id: saltoResources.access_groups?.[0]?.id,
          role_id:
            saltoResources.roles?.find((role) => role.label === "Site User")
              ?.id ?? saltoResources.roles?.[0]?.id,
        },
      ],
    }));
  }

  /**
   * This method will update the access group id on select change
   * @param {int} visitorTypeId
   * @param {string} accessGroupId
   */
  function onAccessGroupChange(visitorTypeId, accessGroupId) {
    setConfigData((prev) => ({
      ...prev,
      visitor_types: prev.visitor_types.map((visitorType) =>
        visitorType.visitor_type_id === visitorTypeId
          ? { ...visitorType, access_group_id: accessGroupId }
          : visitorType,
      ),
    }));
  }

  /**
   * This method will update the role id on select change
   * @param {int} visitorTypeId
   * @param {string} roleId
   */
  function onRoleChange(visitorTypeId, roleId) {
    setConfigData((prev) => ({
      ...prev,
      visitor_types: prev.visitor_types.map((visitorType) =>
        visitorType.visitor_type_id === visitorTypeId
          ? { ...visitorType, role_id: roleId }
          : visitorType,
      ),
    }));
  }

  /**
   * This method will delete a visitor type from the config data
   * @param {int} visitorTypeId
   */
  function onVisitorTypeDelete(visitorTypeId) {
    setConfigData((prev) => ({
      ...prev,
      visitor_types: prev.visitor_types.filter(
        (visitorType) => visitorType.visitor_type_id !== visitorTypeId,
      ),
    }));
  }

  return (
    <SaltoVisitorTypesView
      availableVisitorTypes={availableVisitorTypes}
      onVisitorTypeAdd={onVisitorTypeAdd}
      visitorTypeLabels={visitorTypeLabels}
      configData={configData}
      saltoResources={saltoResources}
      onAccessGroupChange={onAccessGroupChange}
      onVisitorTypeDelete={onVisitorTypeDelete}
      onRoleChange={onRoleChange}
    />
  );
}

export default SaltoVisitorTypes;
